import React from 'react';
import Api from '../../../api/api';
import ResubscribeModal from './ResubscribeModal';
import type { UserType } from '../../../utils/types';

class CurrentExercise extends React.Component {
  state = {
    showModal: false,
  };

  componentDidMount() {
    this.checkPaymentStatusAndFetchExercises();
  }

  checkPaymentStatusAndFetchExercises = () => {
    Api.users
      .getUserPersonalData()
      .then((user: UserType) => {
        if (user.payment_status === 'error') {
          this.props.history.push('/profile');
        } else {
          this.getCurrentWeekExercises();
        }
      })
      .catch(error => error.response.status === 401 && this.props.history.push('/login'));
  };

  getCurrentWeekExercises = () => {
    const search = this.props.location.search;
    const week = search && search.slice(6);

    Api.users
      .getCurrentWeekExercises(week, 'exercises')
      .then(week_plan => {
        if (week_plan.pdf_original_url) {
          // extra endpoint call is handled to inform server about exercise "viewed" status being changed
          Api.users.getCurrentWeekExercises(week).then(exerciseViewedStatusUpdated => {
            if (exerciseViewedStatusUpdated) {
              return (window.location = week_plan.pdf_original_url);
            }
          });
        }
      })
      .catch(error => {
        const { status } = error.response;

        if (status === 401) {
          this.props.history.push('/login');
        }

        if (status === 403) {
          this.setState({ showModal: true });
        }

        if (status === 404 || status === 500) {
          this.props.history.push('/invalid-link');
        }
      });
  };

  handleResubscribe = () =>
    Api.users.subscribe().then(() => {
      this.props.history.push('/profile');
    });

  handleModalClose = () => this.setState({ showModal: false });

  render() {
    return (
      this.state.showModal && (
        <ResubscribeModal show={this.state.showModal} handleResubscribe={this.handleResubscribe} />
      )
    );
  }
}

export default CurrentExercise;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Exercises/CurrentExercise.js